export default "__VITE_ASSET__50a924d8__"